import { Api } from "src/utils/api";
import { ApiResponse } from "src/types/apiResponce";

const BASE_URL = import.meta.env.BUILD_API_BASE_URL;

export interface Country {
  code: string;
  name: string;
}

export class AmazonCountriesService extends Api {
  constructor() {
    super(BASE_URL);
  }

  public async getCountries(): Promise<Country[]> {
    return this.get("/core/api/v1/countries/amazon");
  }

  public async setSelectedCountries(
    countryCodes: string[],
  ): Promise<ApiResponse<any>> {
    const payload = { countries: countryCodes };
    return this.post("/core/api/v1/amazon/ads/countries", payload);
  }
}
